// extracted by mini-css-extract-plugin
module.exports = {"Date":"TimeSlot_Date__3LJ9a","Guaranteed":"TimeSlot_Guaranteed__R9uYY","Selected":"TimeSlot_Selected__3mIf2"};